import React from "react";
import styled from "styled-components";
import { Link } from "react-router";

export default function ImageOverlayCard({
  image,
  title,
  subtitle,
  alt,
  className,
  to,
  onClick,
}) {
  const elementType = to ? Link : onClick ? "button" : "figure";
  const elementProps = to
    ? { to }
    : onClick
    ? { type: "button" }
    : {};

  return (
    <StyledImageOverlayCard
      as={elementType}
      className={className}
      $interactive={Boolean(to || onClick)}
      onClick={onClick}
      {...elementProps}
    >
      <img src={image} alt={alt} loading="lazy" decoding="async" />
      {(title || subtitle) && (
        <span className="image-overlay-card__content">
          {title && <strong>{title}</strong>}
          {subtitle && <span>{subtitle}</span>}
        </span>
      )}
    </StyledImageOverlayCard>
  );
}

const StyledImageOverlayCard = styled.figure`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: 0;
  background-color: var(--dark-blue);
  color: var(--white);
  line-height: normal;
  text-align: left;
  cursor: ${({ $interactive }) => ($interactive ? "pointer" : "default")};

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(
      180deg,
      rgba(4, 16, 40, 0.04) 25%,
      rgba(4, 18, 48, 0.3) 58%,
      rgba(3, 15, 40, 0.88) 100%
    );
    pointer-events: none;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .image-overlay-card {
    &__content {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 2;
      display: grid;
      gap: 6px;
      padding: 28px;
      color: var(--white);
      pointer-events: none;

      strong {
        color: inherit;
        font-size: var(--fs-card-title);
        font-weight: var(--fw-semibold);
        line-height: 1.35;
      }

      & > span {
        color: rgba(255, 255, 255, 0.84);
        font-size: var(--fs-body-sm);
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
      }
    }
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover img {
      transform: scale(1.06);
    }
  }

  &:focus-visible {
    outline: 3px solid var(--light-blue);
    outline-offset: 3px;

    img {
      transform: scale(1.06);
    }
  }

  @media (max-width: 768px) {
    .image-overlay-card {
      &__content {
        padding: 20px;

        strong {
          font-size: clamp(18px, 5vw, 24px);
        }

        & > span {
          font-size: 14px;
        }
      }
    }
  }
`;
